import { memo, useCallback } from 'react'
import Box from '@mui/material/Box'
import { useParams } from 'react-router-dom'
import { ChipResetFilter } from '../../../../shared/ui/ChipResetFilter/ChipResetFilter'
import {
	useAppDispatch
} from '../../../../shared/lib/hooks/useAppDispatch/useAppDispatch'
import {
	useAppSelector
} from '../../../../shared/lib/hooks/useAppSelector/useAppSelector'
import { selectQueryFilters } from '../../model/selectors/selectFilters'
import { instanceEventsActions } from '../../model/slices/InstanceEventsSlice'
import { fetchInstanceEvents } from '../../model/services/fetchInstanceEvents'
import { isISOString } from '../../../../shared/lib/DateAndTieHelpers/isISOString'
import {
	formatISOToReadable
} from '../../../../shared/lib/DateAndTieHelpers/fromISOToReadable'
import { InstanceEventsFilterChip } from './InstanceEventsFilterChip'

interface InstanceEventsFilterChipListProps {
	licenseId: string
}

export const InstanceEventsFilterChipList = memo(
	function InstanceEventsFilterChipList(props: InstanceEventsFilterChipListProps) {
		const { licenseId } = props
		const dispatch = useAppDispatch()
		const { licenseId: licIdFromParams } = useParams()

		const filters = useAppSelector(selectQueryFilters)
		const activeFilters = Object.entries(filters).filter(([_, filterValue]) => filterValue)
		const activeFiltersLen = activeFilters.length

		const handleReset = useCallback(() => {
			dispatch(instanceEventsActions.resetFilter())
			dispatch(instanceEventsActions.setPage(1))
			dispatch(fetchInstanceEvents(licIdFromParams ?? licenseId))
		}, [dispatch, licIdFromParams, licenseId])

		return (
			<>
				{!!activeFiltersLen && (
					<Box sx={{
						marginBottom: '1.5rem',
						display: 'flex',
						gap: 1,
						flexWrap: 'wrap'
					}}>
						<ChipResetFilter handleReset={handleReset} />
						{activeFilters.map(([filterKey, filterValue]) => (
							<InstanceEventsFilterChip
								key={filterKey + filterValue}
								filterKey={filterKey}
								filterValue={isISOString(filterValue)
									? formatISOToReadable(filterValue)
									: filterValue as string
								}
								licenseId={licenseId}
							/>
						))}
					</Box>
				)}
			</>
		)
	})
